import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCompass, FiUser, FiSettings, FiMenu, FiX, FiActivity } = FiIcons;

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/dashboard', label: 'Feed', icon: FiActivity },
    { path: '/explore', label: 'Explore', icon: FiCompass },
    { path: '/alexdoe', label: 'Profile', icon: FiUser },
  ];

  const isHome = location.pathname === '/';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-[60] transition-all duration-300 ${scrolled || !isHome ? 'py-4' : 'py-6'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`relative flex justify-between items-center px-6 py-3 rounded-2xl transition-all duration-500 ${scrolled || !isHome ? 'bg-slate-950/80 backdrop-blur-xl border border-white/10 shadow-2xl' : 'bg-transparent'}`}>
          <Link to="/" className="flex items-center space-x-3 group" aria-label="DidThis Home">
            <div className="bg-white text-slate-950 w-8 h-8 rounded-lg flex items-center justify-center font-black text-sm group-hover:rotate-12 transition-transform">
              dt
            </div>
            <span className="text-xl font-black text-white tracking-tighter italic uppercase">
              DidThis<span className="text-primary">.</span>social
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-2">
            {navItems.map((item) => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`flex items-center space-x-2 px-4 py-2 rounded-xl text-sm font-bold transition-all ${
                  location.pathname === item.path 
                    ? 'bg-white/10 text-white shadow-lg' 
                    : 'text-slate-400 hover:text-white hover:bg-white/5'
                }`}
              >
                <SafeIcon icon={item.icon} className="w-4 h-4" />
                <span>{item.label}</span>
              </Link>
            ))}
            <div className="w-px h-6 bg-white/10 mx-2" />
            <Link to="/settings" aria-label="Settings" className="p-2 text-slate-400 hover:text-white hover:bg-white/5 rounded-xl transition-all">
              <SafeIcon icon={FiSettings} className="w-5 h-5" />
            </Link>
          </div>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)} 
            className="md:hidden p-2 text-white hover:bg-white/10 rounded-xl transition-all"
            aria-expanded={isMenuOpen}
            aria-label="Toggle Menu"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.95 }}
            className="absolute top-full left-0 right-0 px-4 pt-2 md:hidden"
          >
            <div className="bg-slate-900 border border-white/10 rounded-2xl p-4 shadow-2xl space-y-2">
              {navItems.map((item) => (
                <Link 
                  key={item.path} 
                  to={item.path} 
                  onClick={() => setIsMenuOpen(false)}
                  className={`flex items-center space-x-4 p-4 rounded-xl font-bold transition-all ${
                    location.pathname === item.path ? 'bg-primary/10 text-white' : 'text-slate-300 hover:bg-white/5'
                  }`}
                >
                  <SafeIcon icon={item.icon} className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}